import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom';

export const BreadCrumbSecttion = ({ secondParentPageName,pageTitle,secondParentPagePath, parentPageOfCurrentPage, currentPageName, breadCrumbPathName }) => {
    
    return (
        <>

            <div className='breadcrumb-section'>
                <Container>
                    <Row>
                        <Col xs={12} lg={6}>
                            <div className="page-title">
                                <h2 className="gradient-text">{pageTitle}</h2>
                            </div>
                        </Col>
                        <Col xs={12} lg={6}>
                            <nav aria-label="breadcrumb" className="theme-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to = '/landing'>Home</Link></li>
                                    {parentPageOfCurrentPage && <li className="breadcrumb-item" aria-current="page"><Link to = {breadCrumbPathName}>{parentPageOfCurrentPage}</Link></li>}
                                    {secondParentPageName && <li className="breadcrumb-item" aria-current="page"><Link to = {secondParentPagePath}>{secondParentPageName}</Link></li>}
                                    <li className="breadcrumb-item active" aria-current="page">{currentPageName}</li>
                                </ol>
                            </nav>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
